import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { AbstractControl, NgControl, Validators } from '@angular/forms';
import { ISubscription } from 'rxjs/Subscription';
import { formConfigs } from '../../utils/variables.utils';
@Directive({
  selector: '[formControl][appPhoneMask],[formControlName][appPhoneMask]',
})
export class PhoneMaskDirective {
  backspace = false;
  delete = false;
  subscription: ISubscription;
  value = "";
  formConfigs = formConfigs;

  constructor(public ngControl: NgControl, private elementRef: ElementRef<HTMLFormElement>, private renderer: Renderer2) {
    /*set a common autocomplete property to off mode in all the mobile number fields to avoid showing the default 
    suggestions provided by the every browser*/
    if (!this.elementRef.nativeElement.getAttribute('autocomplete')) {
      this.renderer.setAttribute(this.elementRef.nativeElement, 'autocomplete', 'off' + Math.random());
    }
  }

  ngOnInit() {
    // setting common min and max length for the credit card across the entire application
    this.ngControl.control.setValidators(this.hasRequiredValidator() ?
      [Validators.required, Validators.minLength(formConfigs.southAfricanContactNumberMaxLength), Validators.maxLength(formConfigs.southAfricanContactNumberMaxLength)] :
      [Validators.minLength(formConfigs.southAfricanContactNumberMaxLength), Validators.maxLength(formConfigs.southAfricanContactNumberMaxLength)]);
    this.onInputChange();
  }

  ngAfterViewInit() {
    if (this.ngControl?.control?.value) {
      this.onAfterValueChanges(this.ngControl?.control?.value);
    }
  }

  hasRequiredValidator(): boolean {
    const control: AbstractControl = this.ngControl.control!;
    if (!control || !control.validator) {
      return false;
    }

    const validatorFn = control.validator({} as AbstractControl);
    return validatorFn && validatorFn.required ? true : false;
  }

  @HostListener('keydown.backspace', ['$event'])
  keydownBackspace(event) {
    this.backspace = true;
  }

  @HostListener('keydown.delete', ['$event'])
  keydownDelete(event) {
    this.delete = true;
  }

  @HostListener('blur', ['$event'])
  onBlur(event) {
    this.value = event.target.value;
    this.backspace = false;
    this.onAfterValueChanges(this.value);
  }

  @HostListener('input', ['$event'])
  onModelChange(event) {
    this.value = event.target.value;
    this.backspace = false;
  }

  onInputChange() {
    this.subscription = this.ngControl.valueChanges.subscribe(subscribedData => {
      if (!subscribedData) return;
      if (typeof subscribedData === 'string' && subscribedData[0] == '0') {
        subscribedData = subscribedData.slice(1);
      }
      this.onAfterValueChanges(subscribedData);
    });
    this.backspace = false;
    this.delete = false;
  }

  onAfterValueChanges(subscribedData) {
    let data = subscribedData.toString();
    let inputValue: string = this.value;
    var newVal = data.replace(/\D/g, '');
    let start = this.elementRef.nativeElement.selectionStart;
    let end = this.elementRef.nativeElement.selectionEnd;
    if (newVal.length == 0) {
      newVal = '';
    }
    else if (newVal.length <= 2) {
      newVal = newVal.replace(/^(\d{0,2})/, '$1');
    } else if (newVal.length <= 6) {
      newVal = newVal.replace(/^(\d{0,2})(\d{0,3})/, '$1 $2');
    } else if (newVal.length <= 10) {
      newVal = newVal.replace(/^(\d{0,2})(\d{0,3})(\d{0,3})/, '$1 $2 $3');
    } else {
      newVal = newVal.replace(/^(\d{0,2})(\d{0,3})(\d{0,4})/, '$1 $2 $3');
    }
    //you are typing in the middle of below logic
    if (inputValue.length >= start) {
      this.ngControl.control.setValue(newVal, { emitEvent: false });
      this.elementRef.nativeElement.setSelectionRange(start, end);
    } else {
      this.ngControl.control.setValue(newVal, { emitEvent: false });
      if (this.backspace) {
        this.elementRef.nativeElement.setSelectionRange(start, end);
      }
      else if (this.delete) {
        this.elementRef.nativeElement.setSelectionRange(start, end);
      }
    }
  }

  ngOnDestroy() {
    if (this.subscription && !this.subscription.closed) {
      this.subscription.unsubscribe();
    }
  }
}